<template lang="pug">
  Icon.icon(name="notification-comment" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") {{ item.info.externalContact }} ответил на
    Link(:to="{ name: 'task-detail', params: item.info, query: { comment: item.info.commentId } }")  согласование
    |  в задаче
    Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
    |  в проекте
    Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
</template>

<script>
export default {
  name: 'NotificationAgreementAnswer',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
